const defaultCountryDetailsToast = (state = null, action) => {
  if (action.type === "SET_DEFAULT_COUNTRY_DETAILS_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_DEFAULT_COUNTRY_DETAILS_TOAST": {
  //     return action.payload;
  //   }
  //   default: {
  //     return state;
  //   }
  // }
};

export default defaultCountryDetailsToast;
